module.exports = __webpack_public_path__ + "static/media/41.7a3e3774.jpg";